module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img03-17d525c08d7dad707ddbbe0fc3ee0ee9.png";